// extracted by mini-css-extract-plugin
export var boxItems = "_5y-1";
export var boxItemsLg = "_5y-2";
export var button = "_5y-7";
export var buttonHoverless = "_5y-9";
export var buttonLg = "_5y-8";
export var filterGroupBox = "_5y-0";
export var icon = "_5y-3";
export var iconSecondary = "_5y-6";
export var iconWrapper = "_5y-4";
export var iconWrapperLg = "_5y-5";
export var truncatedLabel = "_5y-a";